import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-invalid-selling-price-dialog',
  templateUrl: './invalid-selling-price-dialog.component.html',
  styleUrls: ['./invalid-selling-price-dialog.component.css']
})
export class InvalidSellingPriceDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<InvalidSellingPriceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { invalidProducts: string[] }
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
